// extracted by mini-css-extract-plugin
module.exports = {"filter":"Filter_filter__MOUhf","label":"Filter_label__u1YKq","encabezado":"Filter_encabezado__2MmMS","title":"Filter_title__25oMF"};